import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
// import SearchOutlined from "@mui/icons-material/SearchOutlined";
import { Dialog, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import "./ChatbotListDialog.css";
import AddEditChatbot from "./AddEditChatbot";
import AssignChatbotDialog from "./AssignChatbotDialog";
import "../../Components/Components.css";
import { getChatBotList } from "../../Store/Actions/WABAAction";

const ChatbotListDialog = ({ isOpen, setIsChatbotListDialogShown }) => {
  // const [searchValue, setSearchValue] = useState("");
  const [action, setAction] = useState("");
  const [selectedChatbot, setSelectedChatbot] = useState(null);

  const [isAssignChatbotDialogShown, setIsAssignChatbotDialogShown] =
    useState(false);

  const [isDeleteWarningShown, setIsDeleteWarningShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [chatBotList, setChatBotList] = useState([]);
  // const [filteredChatBotList, setFilteredChatBotList] = useState([]);
  const [anchorElMoreButton, setAnchorElMoreButton] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    fetchChatBotList();
  }, [isOpen]);

  const openMoreButton = Boolean(anchorElMoreButton);

  const columns = [
    {
      field: "ScriptName",
      flex: 1,
      headerName: "Operator Name",
    },

    {
      field: "Status",
      flex: 1,
      headerName: "Status",
      renderCell: () => <p>Inactive</p>,
    },

    {
      field: "ID",
      flex: 1,
      headerName: "ID",
    },

    {
      field: "ActiveOn",
      flex: 1,
      headerName: "Active On",
      renderCell: () => <p>-</p>,
    },

    {
      flex: 0.5,
      headerName: "Action",

      renderCell: (params) => {
        return (
          <IconButton
            disabled={action === "delete" && params.row.Status === "Active"}
            onClick={() => {
              if (action !== "delete") {
                setAction("edit");
              } else {
                setIsDeleteWarningShown(true);
              }

              setSelectedChatbot(params.row);
            }}
          >
            <Icon
              color="#7e7e7e"
              height="26"
              icon={
                action === "delete"
                  ? "material-symbols:delete-outline-rounded"
                  : "ic:baseline-remove-red-eye"
              }
            />
          </IconButton>
        );
      },
    },
  ];

  const fetchChatBotList = () => {
    getChatBotList()
      .then((response) => {
        if (response.status) {
          setChatBotList(response.data);
          // setFilteredChatBotList(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  };

  const handleClickMoreButton = (event) => {
    setAnchorElMoreButton(event.currentTarget);
  };

  const handleCloseMoreButton = () => {
    setAnchorElMoreButton(null);
  };

  const handleClose = () => {
    handleBack();
    setIsChatbotListDialogShown(false);
  };

  const handleBack = () => {
    setAction("");
    setSelectedChatbot(null);
    fetchChatBotList();
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog chatbot-list"
      fullWidth
      maxWidth="xl"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <div className="dialog-content">
          <IconButton className="close-button" onClick={handleClose}>
            <CloseOutlined />
          </IconButton>

          <div className="title">
            {(action === "add" || action === "edit") && (
              <IconButton onClick={handleBack}>
                <Icon
                  height="20"
                  icon="material-symbols:arrow-back-ios-new-rounded"
                />
              </IconButton>
            )}

            <h2>Chatbot List</h2>
          </div>

          <div className="container">
            {action === "add" || action === "edit" ? (
              <AddEditChatbot
                action={action}
                handleBack={handleBack}
                selectedChatbot={selectedChatbot}
              />
            ) : (
              <>
                {/* <div className="contact_search">
                  <div className="search-container">
                    <SearchOutlined className="icon" />

                    <input
                      type="search"
                      className="search"
                      placeholder="Search..."
                      value={searchValue}
                      onChange={(e) => {
                        setSearchValue(e.target.value);

                        setFilteredChatBotList(
                          chatBotList.filter((chatBot) =>
                            chatBot.ScriptName.toLowerCase().includes(
                              e.target.value
                            )
                          )
                        );
                      }}
                    />
                  </div>
                </div> */}

                <header>
                  <button
                    className="assign-button"
                    onClick={() => setIsAssignChatbotDialogShown(true)}
                  >
                    <Icon
                      height="20"
                      icon="material-symbols:robot-2-outline-sharp"
                    />
                    Assign Chatbot
                  </button>

                  <Tooltip
                    arrow
                    placement="left"
                    title={
                      action === "delete" ? "Finish deleting" : "More actions"
                    }
                  >
                    <IconButton
                      className="more-button"
                      onClick={(e) => {
                        if (action === "delete") {
                          setAction("");
                        } else {
                          handleClickMoreButton(e);
                        }
                      }}
                    >
                      <Icon
                        color="#727272"
                        height="36"
                        icon={
                          action === "delete"
                            ? "ph:x-bold"
                            : "material-symbols:more-vert"
                        }
                      />
                    </IconButton>
                  </Tooltip>

                  <Menu
                    className="menu"
                    anchorEl={anchorElMoreButton}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={openMoreButton}
                    onClose={handleCloseMoreButton}
                  >
                    <MenuItem
                      onClick={() => {
                        setAction("add");
                        handleCloseMoreButton();
                      }}
                    >
                      <Icon
                        height="20"
                        icon="material-symbols:add-circle-outline-rounded"
                      />
                      Add Chatbot
                    </MenuItem>

                    <MenuItem
                      onClick={() => {
                        setAction("delete");
                        handleCloseMoreButton();
                      }}
                    >
                      <Icon
                        height="20"
                        icon="material-symbols:delete-outline-rounded"
                      />
                      Delete
                    </MenuItem>
                  </Menu>
                </header>

                <DataGrid
                  autoPageSize
                  className="table"
                  columns={columns}
                  disableColumnFilter
                  disableColumnMenu
                  disableSelectionOnClick
                  loading={isLoading}
                  rows={chatBotList}
                  getRowId={(row) => row.ID}
                />
              </>
            )}
          </div>
        </div>
      </div>

      <Dialog
        open={isDeleteWarningShown}
        className="dialog delete-chatbot-warning"
        fullWidth
        maxWidth="sm"
        scroll="paper"
        onClose={() => {
          setSelectedChatbot(null);
          setIsDeleteWarningShown(false);
        }}
      >
        <div className="dialog-container">
          <div className="dialog-warning">
            <header>
              <Icon height="28" icon="ion:warning" width="28" />
              <p>Warning!</p>
              <Icon height="28" icon="ion:warning" width="28" />
            </header>

            <div className="warning-content">
              <p>Permanently remove "{selectedChatbot?.ScriptName}"?</p>
            </div>

            <div className="buttons">
              <button
                className="cancel"
                onClick={() => {
                  setIsDeleteWarningShown(false);
                  setSelectedChatbot(null);
                }}
              >
                Cancel
              </button>

              <button
                className="confirm"
                onClick={() => {
                  setIsDeleteWarningShown(false);
                  setSelectedChatbot(null);
                  setAction("");
                  toast.success("Removed successfully");
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </Dialog>

      <AssignChatbotDialog
        chatbotList={chatBotList}
        isOpen={isAssignChatbotDialogShown}
        setIsOpen={setIsAssignChatbotDialogShown}
      />
    </Dialog>
  );
};

export default ChatbotListDialog;
